import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRefreshIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.6693 7.99967C14.6693 11.6797 11.6826 14.6663 8.0026 14.6663C4.3226 14.6663 2.07594 10.9597 2.07594 10.9597M2.07594 10.9597H5.08927M2.07594 10.9597V14.293M1.33594 7.99967C1.33594 4.31967 4.29594 1.33301 8.0026 1.33301C12.4493 1.33301 14.6693 5.03967 14.6693 5.03967M14.6693 5.03967V1.70634M14.6693 5.03967H11.7093",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgRefreshIcon;
